export default __webpack_public_path__ + "static/media/p3ti3.fcf29345.png";